import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestMessages = ({ id, qs }: {
  id: string,
  qs: {
    page: number
    per_page: number
  }
}): Action => ({
  type: actionTypes.REQUEST_MESSAGES,
  id,
  qs,
});

export const requestConversationList = ({ userId, callbacks }: {
  userId?: number
  callbacks?: SagaCallbacks,
} = {}): Action => ({
  type: actionTypes.REQUEST_CONVERSATION_LIST,
  userId,
  callbacks,
});

export const requestUnreadCategories = ({ id }: {
  id: number
}): Action => ({
  type: actionTypes.REQUEST_UNREAD_CATEGORIES,
  id,
});

export const requestMarkReadMessages = ({
  ids,
  conversationId,
}: {
  ids: number[]
  conversationId: string
}): Action => ({
  type: actionTypes.REQUEST_MARK_READ_MESSAGES,
  ids,
  conversationId,
});
